import './style/top-nav.less'
import $ from 'jquery'
import topNav from './js/top-nav'
import staticLogin from './js/login'
import lxWrap from '../common/js/lx'
import siteCategory from './js/site-category'
import lxBid from '../common/js/lx-bid'
import { transXSS } from '../common/js/util'


/**
 * 首页导航顶部横条
 */
export default {
    init: (config) => {
        // 初始化顶部站点导航
        // console.log('top-nav');

        let topNavConfig = config;
        let wrapper = $('#top-nav');
        let userCenterTop = $('.header-container #user-center-top');
        let $siteNav = wrapper.find('.J-site-target')
        topNavConfig.wrapper = wrapper
        topNavConfig.isLogin = false;

        // 用户已经登录，从全局获取userId 和 userName
        if (topNavConfig.userId && (topNavConfig.userId + '').length > 1) {
            // if (topNavConfig.userName) { 
                topNavConfig.userName = transXSS(topNavConfig.userName);
            // }
            topNavConfig.isLogin = true;
            topNav.init(topNavConfig);
        } else { // 游客或者静态页，掉登录接口
            staticLogin.init(topNavConfig, function (res) {
                // 静态化登录的
                if (res.code == 200 && res.msg && res.msg.id && res.msg.name) {
                    topNavConfig.isLogin = true;
                    topNavConfig.userId = res.msg.id;
                    topNavConfig.userName = transXSS(res.msg.name);
                    topNav.init(topNavConfig);
                } else { 
                    // 静态化未登录的
                    topNav.init(topNavConfig);
                }
            }, function () { // 请求失败
                    topNav.init(topNavConfig);
                });
        }

        // 顶部网站导航数据异步获取,个人中心页头不进行seo处理
        if (userCenterTop && userCenterTop.length > 0) {
            return
        } else { 
            siteCategory.init(topNavConfig, res => { 
                if (res && res.code == 200) {
                    let siteNavTpl = res.data
                    if ($siteNav && $siteNav.length > 0) { 
                        $siteNav.empty()
                        $siteNav.append(siteNavTpl)
                    }
                    
                } else {
                    console.log('请求导top-nav失败', res)
                }
            })
        }
        



        // web4.0 灵犀打点
        // 写点评
        lxWrap($('.write-dp'), lxBid.writeReviewBid, false, false)
        // 商户服务
        lxWrap($('.J-shop-serve-target a'), lxBid.shopServerBid, true, false)
        // 帮助中心打点
        lxWrap($('.J-help-trigger'), lxBid.helpCenterBid, true, false)
        lxWrap($('.J-help-target a'), lxBid.helpCenterBid, true, false)
        // 消息打点
        lxWrap($('.J-message-target a'), lxBid.messageBid, true, false)
    }
}


// WEBPACK FOOTER //
// ./modules/top-nav/index.js